module.exports = __webpack_public_path__ + "media/images/emblems/Unterlangenegg-coat_of_arms-f23d2c2eaa687492f8842ad0e7d892c2.svg";